/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_SuccessInputs */



/**
* | output |
* | --- |
* | "Chats in this project are now private, with their attached files and AI-created documents." |
*
* @param {Project_Private_Chats_Enable_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_success = /** @type {((inputs?: Project_Private_Chats_Enable_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Chats in diesem Projekt sind jetzt privat, samt angehängten Dateien und KI-erstellten Dokumenten.")
	return /** @type {LocalizedString} */ ("Chats in this project are now private, with their attached files and AI-created documents.")
});